import React, { useMemo, useState } from 'react';
import dayjs from 'dayjs';

import { dataGridPremiumColumns } from '../../utils/helper';
import { DataGridIdentifiers, DatagridPremiumUi } from '../Interface';
import emailMessageService from '../../service/emailMessage.service';

const EmailMessageReports = ({ values, rowSelection }) => {
  const { setSelectedValues } = values;
  const { rowSelectionModel, setRowSelectionModel } = rowSelection;
  const [reports, setReports] = useState({ rows: [], rowCount: 0 });
  const [refetchTable, setRefetchTable] = useState(false);

  const initialState = {
    filter: { filterModel: { items: [], logicOperator: 'and' } },
    sorting: {
      sortModel: [{ field: 'sentDate', sort: 'desc' }],
    },
    pagination: {
      paginationModel: {
        pageSize: 25,
        page: 0,
      },
    },
    density: 'compact',
  };

  const getList = (gridState) => {
    emailMessageService.getItems(gridState).then((data) => {
      const rows = Array.isArray(data) ? data : data?.rows ?? [];
      const rowCount = Array.isArray(data) ? data.length : data?.rowCount ?? rows.length;

      setReports({ rows, rowCount });
    });
  };

  const columns = useMemo(
    () =>
      dataGridPremiumColumns([
        {
          field: 'sentDate',
          headerName: 'Küldés ideje',
          type: 'dateTime',
          width: 180,
          valueGetter: (_value, row) => (row.sentDate ? new Date(row.sentDate) : null),
          renderCell: (params) => (params.row.sentDate ? dayjs(params.row.sentDate).format('YYYY.MM.DD. HH:mm') : ''),
        },
        {
          field: 'status',
          headerName: 'Státusz',
          type: 'string',
          width: 110,
        },
        {
          field: 'emailTo',
          headerName: 'Címzett',
          type: 'string',
          flex: 1,
          minWidth: 220,
        },
        {
          field: 'subject',
          headerName: 'Tárgy',
          type: 'string',
          flex: 1,
          minWidth: 220,
        },
        {
          field: 'documentTypeId',
          headerName: 'Bizonylattípus',
          type: 'string',
          minWidth: 180,
          renderCell: (params) => params.row.documentType?.name ?? '',
        },
        {
          field: 'userId',
          headerName: 'Feladó',
          type: 'string',
          minWidth: 160,
          renderCell: (params) => params.row.user?.userName ?? '',
        },
      ]),
    []
  );

  return (
    <DatagridPremiumUi
      datagridIdentifier={DataGridIdentifiers.emailMessage}
      datagridInitialState={initialState}
      dataLoader={getList}
      rows={reports.rows}
      refetch={{ refetchTable, setRefetchTable }}
      rowCount={reports.rowCount}
      columns={columns}
      onRowClick={(rowData) => {
        setSelectedValues(rowData.row);
      }}
      paginationAndfilterMode="server"
      onRowSelectionModelChange={(newRowSelectionModel) => {
        setRowSelectionModel(newRowSelectionModel);
      }}
      rowSelectionModel={rowSelectionModel}
      getRowId={(row) => row.id}
    />
  );
};

export default EmailMessageReports;
